"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const task_repository_1 = require("./task.repository");
const typeorm_1 = require("typeorm");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils/masters-validation");
const look_up_service_1 = require("../../../../org-service/src/app/look-up/look-up.service");
const constants_2 = require("../../../../service-lib/src/lib/constants");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
let TaskService = class TaskService {
    constructor(taskRepository, dataSource, lookUpValidation, masterValidation, lookUpService) {
        this.taskRepository = taskRepository;
        this.dataSource = dataSource;
        this.lookUpValidation = lookUpValidation;
        this.masterValidation = masterValidation;
        this.lookUpService = lookUpService;
    }
    async createTask(taskData, entityManager) {
        try {
            const createTask = async (manager) => {
                await this.lookUpValidation.validateDynamicLookupValues(taskData, constants_1.LOOK_UP_DATA);
                await this.masterValidation.validateMasterIds(taskData, constants_1.MASTER_DATA);
                const { documents, ...taskDetails } = taskData;
                // default values for task status and task type
                const taskStatus = await this.lookUpService.getLookUpsByKey(constants_1.DEFAULT_TASK_STATUS);
                if (!taskStatus) {
                    throw new common_1.NotFoundException(`Task status with key ${constants_1.DEFAULT_TASK_STATUS} not found.`);
                }
                const taskType = await this.lookUpService.getLookUpsByKey(constants_2.TASK_TYPE.TASK);
                if (!taskType) {
                    throw new common_1.NotFoundException(`Task type with key ${constants_2.TASK_TYPE.TASK} not found.`);
                }
                const taskPriority = await this.lookUpService.getLookUpsByKey(constants_2.PRIORITY_LOOK_UP_MEDIUM_VALUE);
                if (!taskPriority) {
                    throw new common_1.NotFoundException(`Task priority with key ${constants_2.PRIORITY_LOOK_UP_MEDIUM_VALUE} not found.`);
                }
                taskDetails.priorityLid = taskDetails.priorityLid || taskPriority[0].id;
                taskDetails.taskStatusLid =
                    taskDetails.taskStatusLid || taskStatus[0].id;
                taskDetails.taskTypeLid = taskDetails.taskTypeLid || taskType[0].id;
                if (taskDetails.taskTypeLid == taskType[0].id) {
                    taskDetails.taskIsEditable = constants_1.IS_EDITABLE;
                }
                else {
                    taskDetails.taskIsEditable = constants_1.IS_NOT_EDITABLE;
                }
                const task = await this.taskRepository.createTask(taskDetails, manager);
                if (documents && documents.length > 0) {
                    await this.taskRepository.createTaskDocuments(documents, task.id, manager);
                }
                return { id: task.id };
            };
            if (entityManager) {
                return await createTask(entityManager); // Use the provided transaction
            }
            else {
                return await this.dataSource.transaction(createTask); // Start a new transaction
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    async getTasks(page, limit, search, sort, userId, searchBy, showCompleted = false) {
        try {
            const searchParams = (0, helper_utils_1.mapSearchParams)(search);
            const sortParams = (0, helper_utils_1.mapSortParams)(sort);
            let statusId;
            if (!showCompleted) {
                const active = await this.lookUpService.getLookUpsByKey(constants_2.TASK_STATUS_ACTIVE);
                statusId = active?.[0]?.id;
            }
            const tasks = await this.taskRepository.getTasks(page, limit, searchParams, sortParams, userId, searchBy, statusId);
            return tasks;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new Error(messages_1.errorMessages.taskListRetrievalFailed);
        }
    }
    async getTaskById(id) {
        try {
            const task = await this.taskRepository.getTaskById(id);
            if (!task) {
                throw new common_1.NotFoundException(messages_1.errorMessages.taskNotFound);
            }
            return task;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    async updateTask(id, updateTaskData, entityManager, fromActivity = false) {
        try {
            const updateTask = async (manager) => {
                const { documents, ...taskDetails } = updateTaskData;
                await this.taskRepository.updateTask(id, taskDetails, manager, fromActivity);
                if (documents && documents.length > 0) {
                    await this.taskRepository.updateTaskDocuments(documents, id, manager);
                }
                return { id };
            };
            if (entityManager) {
                return await updateTask(entityManager); // Use the provided transaction
            }
            else {
                return await this.dataSource.transaction(updateTask); // Start a new transaction
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    async completeTask(id, entityManager) {
        try {
            const complete = async (manager) => {
                await this.taskRepository.completeTask(id, manager);
                return { id };
            };
            if (entityManager) {
                return await complete(entityManager);
            }
            else {
                return await this.dataSource.transaction(complete);
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException ||
                error instanceof common_1.BadRequestException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    async deleteTaskById(id) {
        try {
            await this.taskRepository.deleteTaskById(id);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    async getTasksByOpportunityAndActivity(opportunityId, activityId) {
        try {
            return await this.taskRepository.getTasksByOpportunityAndActivity(opportunityId, activityId);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error
                ? error.message
                : "Failed to fetch tasks for the given opportunity and activity.");
        }
    }
};
exports.TaskService = TaskService;
exports.TaskService = TaskService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof task_repository_1.TaskRepository !== "undefined" && task_repository_1.TaskRepository) === "function" ? _a : Object, typeof (_b = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _b : Object, typeof (_c = typeof lookup_validation_1.LookUpValidationService !== "undefined" && lookup_validation_1.LookUpValidationService) === "function" ? _c : Object, typeof (_d = typeof masters_validation_1.MasterValidationService !== "undefined" && masters_validation_1.MasterValidationService) === "function" ? _d : Object, typeof (_e = typeof look_up_service_1.LookUpService !== "undefined" && look_up_service_1.LookUpService) === "function" ? _e : Object])
], TaskService);
